import React from 'react';
import { Link } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

const ListaPerfil = (props) => {
    return (
        <ul className="dropdown-menu dropdown-profiles no-padding">
            <div className="punta"></div>
            {(props.functions.Modificacion == true) &&
                <li>                    
                    <a className="clickable" onClick={() => props.setPerfilEdicion(props.id, props.gruposWindows)}>Editar perfil</a>                    
                </li>}
            {(props.functions.Modificacion == true) &&
                <li>
                    <Link to={ProcessManager.GetNextStep("PerfilesyPermisos", "ROUTE_TO_ASIGNAR_PERFIL") + "/" + props.id + '1'}>
                        <a className="clickable">Asignar a usuarios</a>
                    </Link>
                </li>}
            {(props.functions.Modificacion == true) &&
                <li>
                    <Link to={ProcessManager.GetNextStep("PerfilesyPermisos", "ROUTE_TO_ASIGNAR_PERFIL") + "/" + props.id + '2'}>
                        <a className="clickable">Des-Asignar a usuarios</a>
                    </Link>
                </li>}
            {(props.functions.Consulta == true) &&
                <li>
                    <Link to={ProcessManager.GetNextStep("PerfilesyPermisos", "ROUTE_TO_USUARIOS_POR_PERFIL") + "/" + props.id}>
                        <a className="clickable">Ver usuarios con este perfil</a>
                    </Link>
                </li>}
            {(props.functions.Consulta == true) &&
                <li>
                    <Link to={ProcessManager.GetNextStep("PerfilesyPermisos", "ROUTE_TO_PERMISOS_PERFIL") + "/" + props.id}>
                    <a className="clickable">Ver todos los permisos de este perfil</a>
                    </Link>
                </li>}
            {(props.functions.Baja == true) && <li>
                <a className="clickable" onClick={() => props.setInfoPerfilToDelete(props.id)}>Eliminar</a>
            </li>}
        </ul>
    );
}

export default ListaPerfil;